/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneStateProviders from 'base/components/standalone/StateProviders';

export const DynamicStandaloneStateProviders = StandaloneStateProviders;
export type DynamicStandaloneStateProvidersProps = PropsFromComponent<typeof StandaloneStateProviders>;

export const DynamicStandaloneStateProvidersWith = (extras: DynamicStandaloneExtras): typeof StandaloneStateProviders => {
    return function DynamicStandaloneStateProviders(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'StateProviders');
        return <StandaloneStateProviders {...mergeProps({ options: { theme } }, props)} />;
    }
}